import { FormattedMessage } from 'react-intl';
import useUser from '@alltrails/context/hooks/useUser';
import Button from '@alltrails/denali/components/Button';
import type Coupon from '@alltrails/types/Coupon';
import type { User } from '@alltrails/types/User';

type Props = {
  coupon?: Coupon;
  submitting: boolean;
};

function getButtonText(user: User, coupon?: Coupon) {
  if (coupon && coupon.type !== 'FreeTrialCoupon') {
    return <FormattedMessage defaultMessage="Save today" />;
  }

  return user.isPromoEligible ? <FormattedMessage defaultMessage="Start your free trial" /> : <FormattedMessage defaultMessage="Upgrade" />;
}

export default function StripeCheckoutSubmitButton({ coupon, submitting }: Props) {
  const user = useUser()!;

  return <Button loading={submitting} text={getButtonText(user, coupon)} type="submit" variant="primary" width="full" />;
}
